// convert number to type thousand
function numberFormatToThousand(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default numberFormatToThousand